import * as type from './types';

export function registerBussiness(data) {
    return {
      type: type.POST_REGISTER_BUSINESS_REQUESTED,
      data:data,
    }
  }